"use client";

import TrackingEvent from "@/components/events/tracking-event";
import { getGtmIntegrationSourceProps } from "@/lib/tracking/gtm-integration-source";
import type { IntegrationSource } from "@/lib/checkout/integration-sources";

export const ConfirmationPageStates = [
  "success",
  "deferred",
  "failed",
] as const;

export type ConfirmationPageState = (typeof ConfirmationPageStates)[number];

export const ConfirmationPageTrackingEvent = ({
  state,
  integrationSource = "none",
}: {
  state: ConfirmationPageState;
  integrationSource?: IntegrationSource;
}) => (
  <TrackingEvent
    eventName="confirmation_page_view"
    eventProps={{
      state,
      ...getGtmIntegrationSourceProps(integrationSource),
    }}
  />
);
